type LogLevel = 'debug' | 'info' | 'warn' | 'error'

const isDev = import.meta.env.DEV

const canLog = (level: LogLevel): boolean => {
  if (level === 'error') {
    return true
  }

  return isDev
}

const log = (level: LogLevel, message: string, ...args: unknown[]): void => {
  if (!canLog(level)) {
    return
  }

  const logger = console[level] ?? console.log
  logger(`[web] ${message}`, ...args)
}

export const appLogger = {
  debug: (message: string, ...args: unknown[]) => log('debug', message, ...args),
  info: (message: string, ...args: unknown[]) => log('info', message, ...args),
  warn: (message: string, ...args: unknown[]) => log('warn', message, ...args),
  error: (message: string, ...args: unknown[]) => log('error', message, ...args),
}
